export const USER_TYPE_S_ADMIN = 'S';
export const USER_TYPE_A_MASTER = 'A';
export const USER_TYPE_B_BIN_FEN_SEED_FARM = 'B';
export const USER_TYPE_C_EXTERNAL_SEED_FARM = 'C';
export const USER_TYPE_D_DISTRIBUTION_STATION = 'D';
export const USER_TYPE_E_BIN_FEN_CUSTOMER = 'E';
export const USER_TYPE_F_EXTERNAL_CUSTOMER = 'F';
export const USER_TYPE_G_CUSTOMER_MANAGER = 'G';
export const USER_TYPE_H_STOREKEEPER = 'H';
export const USER_TYPE_M_CUSTOMER_SERVICE = 'M';
export const USER_TYPE_I_FINANCE = 'I';
export const USER_TYPE_I_FINANCE_2 = 'I2';
export const USER_TYPE_J_INSPECTOR = 'J';
export const USER_TYPE_P_PROJECT = 'P';

export const formatUserType = userType => {
    switch (userType) {
        case USER_TYPE_S_ADMIN:
            return '管理员';
        case USER_TYPE_A_MASTER:
            return '专家';
        case USER_TYPE_B_BIN_FEN_SEED_FARM:
            return '缤纷种苗场';
        case USER_TYPE_C_EXTERNAL_SEED_FARM:
            return '外部种苗场';
        case USER_TYPE_D_DISTRIBUTION_STATION:
            return '转运站';
        case USER_TYPE_E_BIN_FEN_CUSTOMER:
            return '缤纷客户';
        case USER_TYPE_F_EXTERNAL_CUSTOMER:
            return '外部客户';
        case USER_TYPE_G_CUSTOMER_MANAGER:
            return '客户经理';
        case USER_TYPE_H_STOREKEEPER:
            return '仓管员';
        case USER_TYPE_M_CUSTOMER_SERVICE:
            return '客服';
        case USER_TYPE_I_FINANCE:
            return '财务';
        case USER_TYPE_I_FINANCE_2:
            return '财务2';
        case USER_TYPE_J_INSPECTOR:
            return '市场部门总监';
        case USER_TYPE_P_PROJECT:
            return '客户经理项目人';
        default:
            return '';
    }
};
